module.exports = __webpack_public_path__ + "img/discover.fbb02c7c.svg";